<template>
	<div>
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>DASHBOARD ITEM</h4>
			</div>

			<div class="col-md-12 mb-0">
				<div class="row">
					<div class="col-md-12">
						<div class="card cardptpr mb-4">
							<div class="card-header cardptpr p-3 pb-0 pt-0">
								<H6>DEPARTMENT</H6>
							</div>
							<div class="card-body p-3 pt-0" style="width:600px;">
								<PieChart :data="piechartdata" :url="''" :legendposition="'left'"/>
							</div>
						</div>
                    </div>
				</div> 
				<div class="row">
					<div class="col-md-6 mb-0">
						<ListItem warning=1 title="5 BEST ITEM" prefix="" :data="bestitem" itemcol="itemname" valuecol="totalsales"
							url=""/>
						<Loader v-if="loading.topfive"/>
					</div>
					<div class="col-md-6 mb-0">
						<ListItem warning=1 title="5 WORST ITEM" prefix="" :data="worstitem" itemcol="itemname" valuecol="totalsales"
							url=""/>
						<Loader v-if="loading.topfive"/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="card cardptpr mb-4">
							<div class="card-header cardptpr p-3 pb-0 pt-0">
								<H6>MONTHLY GROWTH BASED ON DEPARTMENT</H6>
							</div>
							<div class="card-body pt-4 pl-3 pr-3" style="width:100%;">
								<table class="app-table" style="width: 100%;">
									<tr>
										<td class="thead text-left">Department</td>
										<td class="thead text-center">QTY Last Month</td>
										<td class="thead text-center">QTY This Month</td>
										<td class="thead text-center">Last Month Sales</td>
										<td class="thead text-center">This Month Sales</td>
										<td class="thead text-center">Growth By QTY</td>
										<td class="thead text-center">Growth By Sales</td>
									</tr>

									<tr v-for="(item,idx) in monthlygrowthdata.data" :key="idx">
										<td>{{ item['departmentnama'] }}</td>
										<td class="text-right">{{ formatNum(item['last_month_qty']) }}</td>
										<td class="text-right">{{ formatNum(item['this_month_qty']) }}</td>
										<td class="text-right">{{ formatNum(item['last_month_sales']) }}</td>
										<td class="text-right">{{ formatNum(item['this_month_sales']) }}</td>
										<td class="text-right">{{ formatNum(item['growth_byqty']) }}</td>
										<td class="text-right">{{ formatNum(item['growth_bysales']) }}</td>
									</tr>
								</table>
							</div>
						</div>
                    </div>
				</div> 
			</div>

			<div class="col-md-12 p-0">
				<el-card shadow="never" class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div slot="header" class="clearfix">
						<span><strong>Dashboard Item</strong></span>
					</div>
					<div>
						<div class="row" v-if="false">
							<div class="mb-3">          
								<el-collapse style="margin-top: -21px;">
									<el-collapse-item>
										<template slot="title">
											<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
										</template>
										<el-form label-position="top" label-width="100px" class="ml-2">
											<div class="row">
												<div class="col-md-6">
													<el-form-item label="Department Name:">
														<el-select v-model="branchid" clearable filterable placeholder="Select Department" size="medium" style="width:100%;" name="branchid">
															<el-option v-for="item3 in store.list" :key="item3.BranchId" :label="item3.BPOSBranchName" :value="item3.BranchId">
															</el-option>
														</el-select>
													</el-form-item>
												</div>
												<div class="col-md-6">
													<el-form-item label="Area:">
														<el-select v-model="branchid" clearable filterable placeholder="Select Store" size="medium" style="width:100%;" name="branchid">
															<el-option v-for="item3 in store.list" :key="item3.BranchId" :label="item3.BPOSBranchName" :value="item3.BranchId">
															</el-option>
														</el-select>
													</el-form-item>
												</div>
											</div>

											<div class="row">
												<div class="col-md-6">
													<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
												</div>
											</div>
																					
										</el-form>
									</el-collapse-item>
								</el-collapse>
							</div>
						</div>

						<div class="mb-3" style="margin-top:0px;">   
							<div class="mt-0">
                                <ReportResultTable :reportname="'PLReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/>                           
                            </div>
						</div>
					</div>
				</el-card>	
			</div>
		</div>

	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import ReportResultTable from '@/views/pages/ReportResultTable3.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'

import Loader from '@/components/loader/Loader2.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/PieChart.js'
import ListItem from '@/views/pages/ListItemAlwaysShow.vue'

export default
{
	extends: Bright,
	components: { 
		ReportResultTable,
		ListItem,
		//LineChart,
		//BarChart,
		PieChart,
		//VendorReportTab,
		//FinanceReportTab,
        Loader,
	},

	data(){
		return {
            loading: {
				table: false,
				chart: false,
				isSuccess: false,
				topfive: false,
			},
            reportdata: [],
			piechartdata: [],
            urlRequestParams: '',
            dialogVisible: false,
			bestitem:[],
			worstitem:[],
			monthlygrowthdata: [],
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
		this.getPiechart()
		this.getTopFive()
		this.getMonthlyGrowth()
        this.loadData()
    },
    methods:{
        async loadData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams+='/bright/dashboard-item?'

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			//this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			//this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

			//this.urlRequestParams+='&period='+this.period

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
					this.loading.isSuccess = true;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

		getPiechart() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/bright/pie-chart-item?'
			
			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			/*
			this.urlRequestParams+='&branch='+this.filter.branch
			this.urlRequestParams+='&branchto='+this.filter.branchto
			if (this.filter.dateRange !== null && this.filter.dateRange.length > 0) {
			this.urlRequestParams+='&startDate='+ this.filter.dateRange[0]
			this.urlRequestParams+='&endDate='+ this.filter.dateRange[1]
			}
			*/

			//this.urlRequestParams+='&branch='+this.branchId

			this.loading.piechart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{ 
				//this.chartresponsedata = response.data.data;
				//this.chartdata = this.processBarChart(this.chartresponsedata, "legend", "", "price", false, "period", "", 1, 2, Rainbow, false, false, false, this.stacked);
			
				let responsedata = response.data.data
				
				let item = responsedata
				var warna = []
				let value = [];
				let idx = 0;
				for (var row in item) {
					//add color
					warna[item[row].departmentnama] = Rainbow[idx];//'#FFB22E'

					//add value
					let main = {
						transtype: item[row].departmentnama, 
						amount: item[row].rate,
					};

					value.push(main);
					idx++;
				}

				this.piechartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.piechart = false;
			})

		},

		getTopFive() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams+='/bright/top-five-item?'

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			//this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			//this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

			//this.urlRequestParams+='&period='+this.period

			this.loading.topfive = true;
			//this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					let reportdata = response.data;
					//this.loading.isSuccess = true;

					this.bestitem = reportdata.best_item
					this.worstitem = reportdata.worst_item
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.topfive = false;
				})
        },

		getMonthlyGrowth() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams+='/bright/growth-by-month-item?'

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End
			//this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			//this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

			//this.urlRequestParams+='&period='+this.period

			this.loading.topfive = true;
			//this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.monthlygrowthdata = response.data;
					//this.loading.isSuccess = true;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.topfive = false;
				})
        },

		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.app-table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius:4px;
}

.app-table td, .app-table th {
  border: 2px solid #fff/*#ddd*/;
  padding: 4px 10px;
}

.app-table tr:nth-child(even){background-color: #F1F4F8/*#D9E1F2*//*#f2f2f2*/;}

.app-table tr:hover {background-color:rgba(240, 240, 240, 1)  /*#ddd*/;}

.app-table th {
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: center;
  background-color: #ffffff/*#0070C0*/;
  color: #1E1E1E;
}

.th-yellow {
    font-weight:bold;
    color:#1E1E1E !important;
    font-size:16px;
    background: #FFFF00 !important;
}

.el-dialog__body {
    word-break: normal !important;
}

.thead {
	padding-top: 6px;
	padding-bottom: 6px;
	text-align: center;
	background-color: #ffffff/*#0070C0*/;
	color: #474747;
	font-weight: bold;
}

</style>